export default function ({ store, redirect }) {
  // if (store.state.user.auth.role !== 'doctor') { redirect('/auth/login') }
}
